const VideoFragment = () => ({
  isPlaying: false,
  isSoundOn: true,
  openOverlay: false,
  handlePlayback() {
    const video = this.$refs.video;
    if (video.paused) {
      video.play();
      this.isPlaying = true;
    } else {
      video.pause();
      this.isPlaying = false;
    }
  },
  handleSound() {
    const video = this.$refs.video;
    if (video.muted) {
      video.muted = false;
      this.isSoundOn = true;
    } else {
      video.muted = true;
      this.isSoundOn = false;
    }
  },
  handleOverlay() {
    const overlay = this.$refs.overlay;
    if (overlay.style.display === 'none') {
      overlay.style.display = 'block';
      this.openOverlay = true;
    }
  }
});

export default VideoFragment;
